<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0">
							<v-row>
								<v-col class="pb-0 pt-0">
									<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">
										{{ $t('titles.candidateCourses') }}</v-card-title
									>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<TheTable
										:additional-filters="candidateCoursesTable.additionalFilters"
										:default-sort="candidateCoursesTable.defaultSort"
										:excel="false"
										:fields="candidateCoursesTable.headers"
										:header-selection-key="'candidate-courses-headers'"
										:height="candidateCoursesTable.height"
										:total-records="candidateCoursesTable.total"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in candidateCoursesTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
											@contextmenu.prevent="redirect(props.item.planned_course_id)"
										>
											<td
												v-if="candidateCoursesTable.selectedHeaders.includes('course_code')"
												@click="redirect(item.planned_course_id)"
											>
												{{ item.planned_course.course.code }}
											</td>
											<td
												v-if="
													candidateCoursesTable.selectedHeaders.includes(
														'planned_course_code'
													)
												"
												@click="redirect(item.planned_course_id)"
											>
												{{ item.planned_course.code ? item.planned_course.code : '-' }}
											</td>
											<td
												v-if="candidateCoursesTable.selectedHeaders.includes('course_name')"
												@click="redirect(item.planned_course_id)"
											>
												{{ item.planned_course.course.name }}
											</td>
											<td
												v-if="candidateCoursesTable.selectedHeaders.includes('end_date')"
												@click="redirect(item.planned_course_id)"
											>
												{{
													item.planned_course.end_date != null
														? item.planned_course.end_date.split('-').reverse().join('.')
														: ''
												}}
											</td>
											<td
												v-if="candidateCoursesTable.selectedHeaders.includes('course_status')"
												@click="redirect(item.planned_course_id)"
											>
												{{ item.planned_course.planned_course_status_name }}
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'CandidateCourses',
	components: { TheTable },
	props: {
		candidateId: [String, Number],
	},
	data: function () {
		return {
			candidateCoursesTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.code'),
						value: 'course_code',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.plannedCourseNumber'),
						value: 'planned_course_code',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.name'),
						value: 'course_name',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.endDate'),
						value: 'end_date',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.status'),
						value: 'course_status',
						type: '',
						sortable: false,
						allowFilter: true,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
		};
	},
	methods: {
		selectHeaders(headers) {
			this.candidateCoursesTable.selectedHeaders = headers;
		},
		redirect(id) {
			this.$router.push('/planned-courses/' + id);
		},
		reloadData(request) {
			this.candidateCoursesTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'candidates-courses/' + this.candidateId,
				request,
				(data, success) => {
					if (success) {
						vm.candidateCoursesTable.items = data.items;
						vm.candidateCoursesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.candidateCoursesTable.height = window.innerHeight - 300 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
